import React, { Fragment, useCallback,useState,useEffect } from 'react';
import classnames from 'classnames';

import {
    required, minLength, maxLength, minValue, maxValue, useRefresh,
    number, regex, email, choices,
    TabbedForm, FormTab, ReferenceInput,
    Edit, SimpleForm, TextInput, RichTextField, FileInput,FileField,
    SelectInput, EditButton, NumberField, DateField,
    DateInput, BooleanInput, NumberInput, ImageInput, ImageField, FormDataConsumer,
    ReferenceManyField, ReferenceField, Datagrid, TextField, BooleanField,AutocompleteInput
} from 'react-admin';
import EditIcon from '@material-ui/icons/Edit';
import { useStyles } from "../../formStyles";
import { Drawer, useMediaQuery, makeStyles } from '@material-ui/core';
import CustomLogoInputDisplay from "../../CustomImage";
import { CreateToolbar } from "../../CreateToolbar";
import Button from '@material-ui/core/Button';
import { AddScoringTypeDetail } from './AddScoringTypeDetail';
import VSDeleteButton from "../../VSDeleteButton";
import { EditScoringTypeDetail } from './EditScoringTypeDetail';
const useMyStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
    },
    list: {
        flexGrow: 1,
        transition: theme.transitions.create(['all'], {
            duration: theme.transitions.duration.enteringScreen,
        }),
        marginRight: 0,
    },
    listWithDrawer: {
        marginRight: 300,
    },
    drawerPaper: {
        zIndex: 100,
        marginTop: 50,
        width: "90%",
    },
}));
export const ModuleEdit = props => {
    const formClasses = useStyles({});
    const classes = useMyStyles({});
    const [isAddDetail, setIsAddDetail] = useState(false);
    const [isEditDetail, setIsEditDetail] = useState(false);
    const [IsEditRecord, setIsEditRecord] = useState(null);
    const refresh = useRefresh();
    const CustomEdit = (props) => {
        let { record } = props;
        return <Button
            color="secondary" disableElevation
            size="medium"

            onClick={() => {
                props.onClick(record);
            }}
            startIcon={<EditIcon />}>{props.title}</Button>
    }
    const HtmlTextField = ({ source, record = {} }) => (
        <span  dangerouslySetInnerHTML={{ __html: record[source] }} />
    );
    const onCancel = () => {
        setIsAddDetail(false);
        setIsEditDetail(false);
        refresh();

    }


    return (
        <>
            <Edit {...props} title="Edit Scoring Type">
                <TabbedForm toolbar={<CreateToolbar {...props} />} variant="outlined">
                    <FormTab label="Scoring Type">
                        <TextInput source="code" validate={required()} fullwidth={true} />
                        <TextInput source="name" validate={required()} fullwidth={true} />
                        <BooleanInput initialValue={true} source="isActive" validate={required()} label="Active" />
                    </FormTab>
                    <FormTab label="Scoring Detail">
                    <Button variant="contained" onClick={() => setIsAddDetail(true)}
                            color="secondary">
                            Add Detail

                        </Button>
                        <ReferenceManyField perPage={100} reference="scoring-type-details" target="scoringTypeId" addLabel={false} fullWidth={true}>
                        <div style={{ maxHeight: "500px", overflow: "auto", paddingRight: "10px" }}>

                            <Datagrid>
                                <VSDeleteButton {...props} />
                                <CustomEdit title="Edit" onClick={(record) => {
                                    setIsEditRecord(record); setIsEditDetail(true);
                                }} />
                                <HtmlTextField source="level01" label="Level 1"  style={{ width: "150px" }} />
                                <HtmlTextField source="level02" label="Level 2"  style={{ width: "150px" }} />
                                <HtmlTextField source="level03" label="Level 3"  style={{ width: "150px" }} />
                                <HtmlTextField source="level04" label="Level 4"  style={{ width: "150px" }}/>
                                <HtmlTextField source="level05" label="Level 5"  style={{ width: "150px" }}/>
                                {/* <HtmlTextField source="level06" label="Level 6" />
                                <HtmlTextField source="level07" label="Level 7" />
                                <HtmlTextField source="level08" label="Level 8" />
                                <HtmlTextField source="level09" label="Level 9" />
                                <HtmlTextField source="level10" label="Level 10" /> */}
                                <TextField source="sortingOrder" label="Sorting Order" />
                                <ReferenceField source="createdBy" reference="users" label="Created By" link={false}>
                                    <TextField source="userName" />
                                </ReferenceField>
                                <DateField source="createdDate" label="Created Date" />
                                <ReferenceField source="modifyBy" reference="employees" label="Modified By" link={false}>
                                    <TextField source="firstName" />
                                </ReferenceField>
                                <DateField source="modifyDate" label="Modified Date" />
                            </Datagrid>
                        </div>
                        </ReferenceManyField>

                    </FormTab>
                </TabbedForm>
            </Edit>
            <Drawer
                anchor="right"
                onClose={onCancel}
                classes={{
                    paper: classes.drawerPaper,
                }}
                open={isAddDetail || isEditDetail
                } >
                {isAddDetail &&
                    <AddScoringTypeDetail
                        onClose={onCancel}
                        onCancel={onCancel}
                        scoringTypeId={props.id}
                        {...props} />}

                {isEditDetail &&
                    <EditScoringTypeDetail
                        onClose={onCancel}
                        onCancel={onCancel}
                        record={IsEditRecord}
                        {...props} />}



            </Drawer>
        </>
    );
}